import { getCategoryHref } from '../../utils/common/category';
import { TEXT_PROMPT_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'textPromptGeneratorType',
      analyticsName: 'text_prompt_type',
      textLabel: 'Generate prompt for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: TEXT_PROMPT_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'Text',
        value: getCategoryHref(TEXT_PROMPT_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'textPromptGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'text_prompt_generator',
      textLabel: 'Describe what text you want to create with AI',
      placeholder: 'E.g., "summary of rental contract" or "SEO article about food technologies."',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: TEXT_PROMPT_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
  {
    type: 'input',
    properties: {
      name: 'textPromptGeneratorDetails',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'text_prompt_generator_details',
      textLabel: 'Include the following details',
      placeholder: 'E.g., styles, platforms, resolutions, etc.',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      isOptional: true,
      selectedCategory: TEXT_PROMPT_GENERATOR_CATEGORY,
      required: false,
      tooltipProps: null,
    },
  },
  {
    type: 'dropdown',
    properties: {
      information: null,
      name: 'length',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'length',
      textLabel: 'Choose length',
      isOptional: true,
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: 19,
      required: false,
      dropdownValues: [
        {
          title: 'Short',
          value: 'short',
        },
        {
          title: 'Medium',
          value: 'medium',
        },
        {
          title: 'Long',
          value: 'long',
        },
      ],
    },
  },
];

export default data;
